export const CASE_DETAILS = {
    CALL_BACK: 'Call back',
    DEATH: 'Death',
    DIAGNOSES: 'Diagnoses',
    GENERAL: 'General',
}

export const CASE_TYPE = {
    BEMIDDELING: 'Bemiddeling',
    OVERLIJDEN: 'Overlijden',
    ONGEVAL: 'Ongeval',
    ZIEKTE: 'Ziekte',
    PLANBAREZORG : 'Planbarezorg' 
}